<script lang="ts" setup>
import { IconDots } from "@tabler/icons-vue";
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<span
		role="presentation"
		aria-hidden="true"
		:class="twMerge('flex h-9 w-9 items-center justify-center', props.class)"
	>
		<slot>
			<IconDots class="h-4 w-4" />
		</slot>
		<span class="sr-only">More</span>
	</span>
</template>
